import { useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import type { CloudUser } from '../auth/AuthContext';
import { apiRequest, jsonBody } from '../platform/api';
import { SiteFooter } from '../components/layout/SiteFooter';

export function ChangeInitialPassword({ user, onSuccess }: { user: CloudUser; onSuccess: () => Promise<void> }) {
  const [submitting, setSubmitting] = useState(false);
  const submit = async (values: { currentPassword: string; newPassword: string; confirmPassword: string }) => {
    if (values.newPassword !== values.confirmPassword) return message.error('两次新密码不一致');
    setSubmitting(true);
    try {
      await apiRequest('/api/auth/change-password', {
        method: 'POST',
        ...jsonBody({ currentPassword: values.currentPassword, newPassword: values.newPassword }),
      });
      message.success('密码已更新');
      await onSuccess();
    } catch (error) {
      message.error(error instanceof Error ? error.message : '密码修改失败');
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <main className="auth-shell">
      <section className="auth-panel">
        <div className="auth-heading">
          <h2>设置新密码</h2>
          <p>{user.username}，首次登录必须修改管理员分配的临时密码</p>
        </div>
        <Form layout="vertical" size="large" onFinish={submit} requiredMark={false}>
          <Form.Item name="currentPassword" label="临时密码" rules={[{ required: true }]}>
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" />
          </Form.Item>
          <Form.Item name="newPassword" label="新密码" extra="至少 10 位，必须同时包含字母和数字" rules={[{ required: true, min: 10 }]}>
            <Input.Password prefix={<LockOutlined />} autoComplete="new-password" />
          </Form.Item>
          <Form.Item name="confirmPassword" label="确认新密码" rules={[{ required: true, min: 10 }]}>
            <Input.Password prefix={<LockOutlined />} autoComplete="new-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={submitting} block>保存并进入</Button>
        </Form>
      </section>
      <SiteFooter />
    </main>
  );
}
